import {
  useAppSearchParams,
  usePaginationQuery,
} from 'shared/libs/hooks/useAppSearchParams'
import { CommonQuery, ParamKey } from 'shared/types/QueryModel'

import { useMemo } from 'react'

import { useGetTableDataQuery } from '../../services/tableApi'

interface Params {
  apiUrl?: string
  filterParams?: ParamKey[]
  skipQuery?: boolean
}
export const useTable = <T,>({
  apiUrl,
  filterParams,
  skipQuery = false,
}: Params) => {
  const { paginationConfig } = usePaginationQuery()
  const { getAllParams } = useAppSearchParams()

  const allParams = getAllParams()
  const queryParams = useMemo(() => {
    return (
      filterParams?.reduce((currentRes, paramKey) => {
        currentRes[paramKey] = `${allParams[paramKey] || ''}`
        return currentRes
      }, {} as CommonQuery) || {}
    )
  }, [allParams, filterParams])

  const { data: tableData, isFetching } = useGetTableDataQuery(
    {
      url: apiUrl as string,
      params: {
        ...queryParams,
        limit: paginationConfig.pageSize,
        offset: paginationConfig.offset,
        ordering: allParams['ordering'],
      },
    },
    {
      skip: !apiUrl || skipQuery,
    },
  )

  const preparedTableData: T[] | null = useMemo(() => {
    if (tableData?.success) {
      return tableData.result.results.map((row) => ({
        ...row,
        id: row.id,
        key: row.id,
      }))
    }
    return null
  }, [tableData])

  return apiUrl
    ? {
        preparedTableData,
        isFetching,
        totalCount: tableData?.result.count ?? 0,
      }
    : null
}
